/*
  Black Friday gift card offer: keeps the amount in step with the cart.

  - Boxes in the theme cart page, empty cart page and cart drawer are rendered
    by snippets/cm-bf-giftcard.liquid; this only updates them.
  - The Vitals app draws its own side cart. This copies the box from
    <template id="CmBfGiftcardTemplate"> into it: above the checkout button,
    or under the "cart is empty" message.

  The cart is re-read (/cart.js) whenever something may have changed it:
  theme cart events, any /cart/add|change|update|clear request on the page,
  the Vitals checkout total changing, the side cart opening, or coming back
  to the tab. Animations pause while a box is off screen.
*/
(function () {
  if (window.cmBfGiftcard) return;
  window.cmBfGiftcard = true;

  var BOX = '[data-cm-bf-giftcard]';
  var TEMPLATE_ID = 'CmBfGiftcardTemplate';
  var VITALS = '#vitals-cart_drawer-container';
  var VITALS_FOOTER = VITALS + ' .Vtl-CartDrawer__Container-FooterContainer';
  var VITALS_EMPTY = VITALS + ' .Vtl-CartDrawerEmptyState';
  var VITALS_CHECKOUT = VITALS + ' .Vtl-CartDrawerCheckout';
  var VITALS_OPEN = VITALS + ' .Vtl-CartDrawer__Container--IsVisible';
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  // Hidden cart attribute with the percentage, read by the checkout block so it
  // shows the same rate as the cart (underscore keeps it out of the buyer's view).
  var RATE_ATTRIBUTE = '_cm_bf_rate';
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var timer;
  var requestId = 0;
  var rateSyncing = false;
  var rateSent = null; // a cart reply that left before our update must not trigger a second one
  var lastCents = null; // survives Vitals redrawing (and replacing) its side cart

  function boxes() {
    return document.querySelectorAll(BOX);
  }

  function formatMoney(cents) {
    var format = window.theme && theme.settings && theme.settings.moneyFormat;
    if (format && theme.Currency && theme.Currency.formatMoney) {
      return theme.Currency.formatMoney(cents, format);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function rateOf(box) {
    return Math.min(100, Math.max(0, parseFloat(box.dataset.rate) || 0));
  }

  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* ---------- rate for the checkout block ---------- */

  // Write the theme percentage into the cart once it has items and differs.
  // The /cart/update.js request below triggers a re-read, which then matches.
  function syncRate(cart) {
    var tpl = document.getElementById(TEMPLATE_ID);
    var box = boxes()[0] || (tpl && tpl.content && tpl.content.querySelector(BOX));
    if (!box || rateSyncing || !cart || !(Number(cart.item_count) > 0)) return;
    var want = String(rateOf(box));
    var have = cart.attributes ? cart.attributes[RATE_ATTRIBUTE] : undefined;
    if (have !== undefined && have !== null && String(have) === want) return;
    if (rateSent === want) return;
    rateSyncing = true;
    rateSent = want;
    var attributes = {};
    attributes[RATE_ATTRIBUTE] = want;
    fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attributes })
    })
      .then(function (res) { if (!res.ok) rateSent = null; })
      .catch(function () { rateSent = null; })
      .then(function () { rateSyncing = false; });
  }

  /* ---------- amount ---------- */

  function render(cart) {
    syncRate(cart);
    var excluded = 0;
    (cart.items || []).forEach(function (item) {
      if (item.gift_card) excluded += item.final_line_price;
    });
    var base = Math.max(0, cart.total_price - excluded);
    var list = boxes();
    if (list.length) lastCents = Math.round((base * rateOf(list[0])) / 100);

    list.forEach(function (box) {
      var rate = rateOf(box);
      var amount = Math.round((base * rate) / 100);
      var prev = parseInt(box.dataset.cents, 10);
      box.dataset.cents = String(amount);
      if (isNaN(prev) || prev !== amount) countTo(box, isNaN(prev) ? amount : prev, amount);
      // A bigger reward after adding to the cart gets a little celebration.
      if (!isNaN(prev) && prev > 0 && amount > prev) bump(box);
      // Nothing to earn yet (empty cart / only gift cards): show the offer itself.
      var mode = amount > 0 ? 'amount' : 'promo';
      if (box.dataset.mode !== mode) box.dataset.mode = mode;
      var hide = rate <= 0;
      if (box.hidden !== hide) box.hidden = hide;
      box.classList.remove('is-updating');
    });
  }

  function setAmountText(box, cents) {
    var text = formatMoney(cents);
    box.querySelectorAll('[data-cm-bf-amount]').forEach(function (el) {
      if (el.textContent !== text) el.textContent = text;
    });
  }

  // Count the amount up (or down) instead of jumping to it.
  function countTo(box, from, to) {
    if (box._cmBfFrame) cancelAnimationFrame(box._cmBfFrame);
    clearTimeout(box._cmBfDone);
    if (reduceMotion || from === to || document.hidden) {
      setAmountText(box, to);
      return;
    }
    var start = null;
    var duration = 700;
    function step(now) {
      if (start === null) start = now;
      var t = Math.min(1, (now - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      setAmountText(box, Math.round(from + (to - from) * eased));
      if (t < 1) box._cmBfFrame = requestAnimationFrame(step);
    }
    box._cmBfFrame = requestAnimationFrame(step);
    // Animation frames can pause (background tab); always land on the real amount.
    box._cmBfDone = setTimeout(function () {
      cancelAnimationFrame(box._cmBfFrame);
      setAmountText(box, to);
    }, duration + 80);
  }

  function bump(box) {
    if (reduceMotion) return;
    box.classList.remove('is-bump');
    void box.offsetWidth; // restart the animation
    box.classList.add('is-bump');
    clearTimeout(box._cmBfBump);
    box._cmBfBump = setTimeout(function () { box.classList.remove('is-bump'); }, 950);
  }

  function refresh() {
    if (!boxes().length) return;
    boxes().forEach(function (box) { box.classList.add('is-updating'); });
    clearTimeout(timer);
    timer = setTimeout(function () {
      var id = ++requestId;
      fetch(cartRoot() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          // Only the newest answer counts; an older one may arrive late.
          if (id === requestId) render(cart);
        })
        .catch(function () {
          boxes().forEach(function (box) { box.classList.remove('is-updating'); });
        });
    }, 250);
  }

  /* ---------- pause animations while off screen ---------- */

  var visibility = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
      }, { rootMargin: '80px' })
    : null;

  function watch(box) {
    if (!visibility || box._cmBfWatched) return;
    box._cmBfWatched = true;
    visibility.observe(box);
  }

  /* ---------- Vitals side cart ---------- */

  function mountVitals() {
    var tpl = document.getElementById(TEMPLATE_ID);
    if (!tpl) return;
    var footer = document.querySelector(VITALS_FOOTER);
    var empty = document.querySelector(VITALS_EMPTY);
    var target = footer || empty;
    if (!target || target.querySelector(BOX)) return;
    var box = tpl.content.firstElementChild.cloneNode(true);
    // Count up from the last amount shown (from zero the first time)
    box.dataset.cents = String(lastCents === null ? 0 : lastCents);
    if (lastCents !== null) {
      setAmountText(box, lastCents);
      box.dataset.mode = lastCents > 0 ? 'amount' : 'promo';
    }
    if (footer) {
      footer.insertBefore(box, footer.firstChild);
    } else {
      box.classList.add('cm-bf--vitals-empty');
      empty.appendChild(box);
    }
    watch(box);
    refresh();
  }

  // Festive background in the Vitals side cart: strip right under its header,
  // confetti layer behind everything (z-index -1 inside the drawer).
  var FX_TEMPLATE_ID = 'CmBfCartFxTemplate';
  function mountVitalsFx() {
    var tpl = document.getElementById(FX_TEMPLATE_ID);
    if (!tpl) return;
    var drawer = document.querySelector(VITALS + ' .Vtl-CartDrawer__Container');
    if (!drawer) return;
    var tickerSrc = tpl.content.querySelector('.cm-bf-ticker');
    var header = drawer.querySelector('.Vtl-CartDrawerHeader');
    if (tickerSrc && header) {
      var ticker = null;
      for (var i = 0; i < drawer.children.length; i++) {
        if (drawer.children[i].classList.contains('cm-bf-ticker')) { ticker = drawer.children[i]; break; }
      }
      if (!ticker) ticker = tickerSrc.cloneNode(true);
      if (header.nextElementSibling !== ticker) header.insertAdjacentElement('afterend', ticker);
    }
    var layerSrc = tpl.content.querySelector('.cm-bf-confetti-layer');
    if (layerSrc) {
      var hasLayer = false;
      for (var j = 0; j < drawer.children.length; j++) {
        if (drawer.children[j].classList.contains('cm-bf-confetti-layer')) { hasLayer = true; break; }
      }
      if (!hasLayer) drawer.appendChild(layerSrc.cloneNode(true));
    }
  }

  // Vitals shows the cart total on its checkout button. If an app changes the
  // cart from somewhere we can't see (e.g. inside an iframe), that text changes.
  var lastVitalsTotal = null;
  var vitalsWasOpen = false;
  function checkVitals() {
    var checkout = document.querySelector(VITALS_CHECKOUT);
    var total = checkout ? checkout.textContent : '';
    if (lastVitalsTotal !== null && total !== lastVitalsTotal) refresh();
    lastVitalsTotal = total;
    var open = !!document.querySelector(VITALS_OPEN);
    if (open && !vitalsWasOpen) refresh();
    vitalsWasOpen = open;
  }

  var frameQueued = false;
  function onDomChange() {
    if (frameQueued) return;
    frameQueued = true;
    requestAnimationFrame(function () {
      frameQueued = false;
      mountVitals();
      mountVitalsFx();
      checkVitals();
    });
  }

  /* ---------- BookThatApp: open the side cart after a booking ---------- */

  // After adding a booking to the cart, BookThatApp asks Bta.callbacks.itemsAddedToCart
  // where to go: a returned string is used as the next URL (relative to the shop root),
  // anything else falls back to its own redirect setting (cart page / checkout).
  // We return the current page with a #fragment, which doesn't reload the page, and
  // open the Vitals side cart instead. Without Vitals we return nothing, so
  // BookThatApp's own redirect still works.
  function installBookingHook() {
    var tpl = document.getElementById(TEMPLATE_ID);
    if (!tpl || tpl.getAttribute('data-bta-drawer') !== 'true') return;
    if (window.Bta && typeof window.Bta !== 'object') return;
    var bta = window.Bta = window.Bta || {};
    bta.callbacks = bta.callbacks || {};
    if (bta.callbacks.itemsAddedToCart) return; // keep a hook someone else set up

    bta.callbacks.itemsAddedToCart = function () {
      var link = document.querySelector('.cmh__cart, a[href$="/cart"]');
      if (!document.getElementById('vitals-cart_drawer-container') || !link) return null;
      setTimeout(function () {
        if (!document.querySelector(VITALS_OPEN)) link.click();
        refresh();
      }, 60);
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      var path = location.pathname.indexOf(root) === 0
        ? location.pathname.slice(root.length)
        : location.pathname.replace(/^\//, '');
      return path + location.search + '#booking-added';
    };
  }

  /* ---------- terms tooltip: hover/focus is CSS; tap toggles it on touch screens ---------- */

  function closeTips(except) {
    document.querySelectorAll('.cm-bf__note.is-open').forEach(function (note) {
      if (note === except) return;
      note.classList.remove('is-open');
      var btn = note.querySelector('.cm-bf__info');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest && evt.target.closest('.cm-bf__info');
    if (!btn) {
      closeTips(null);
      return;
    }
    evt.preventDefault();
    evt.stopPropagation();
    var note = btn.closest('.cm-bf__note');
    var open = !note.classList.contains('is-open');
    closeTips(note);
    note.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }, true);
  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape') closeTips(null);
  });

  /* ---------- when to re-read the cart ---------- */

  // Theme events (quantity change, add to cart, drawer open)
  ['cart:updated', 'cart:build', 'ajaxProduct:added', 'drawerOpen'].forEach(function (name) {
    document.addEventListener(name, refresh);
  });

  // Any script on the page that changes the cart (Vitals, Dealeasy, theme) makes one of these requests.
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        var changed = list.getEntries().some(function (entry) {
          return CART_CHANGE.test(entry.name.replace(location.origin, ''));
        });
        if (changed) refresh();
      }).observe({ type: 'resource', buffered: false });
    } catch (e) {}
  }

  // Back/forward cache, or the cart changed in another tab
  window.addEventListener('pageshow', function (evt) {
    if (evt.persisted) refresh();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });

  function start() {
    boxes().forEach(watch);
    installBookingHook();

    // The cart as Liquid saw it, so pages without a cart change still sync the rate.
    var tpl = document.getElementById(TEMPLATE_ID);
    if (tpl) {
      var known = {};
      if (tpl.hasAttribute('data-cart-rate')) known[RATE_ATTRIBUTE] = tpl.getAttribute('data-cart-rate');
      syncRate({ item_count: tpl.getAttribute('data-cart-count'), attributes: known });
    }

    // The theme rebuilds the subtotal when the cart changes; a fallback for changes without an event.
    document.querySelectorAll('[data-subtotal]').forEach(function (el) {
      new MutationObserver(refresh).observe(el, { childList: true, characterData: true, subtree: true });
    });

    if (document.getElementById(TEMPLATE_ID)) {
      new MutationObserver(onDomChange).observe(document.body, { childList: true, subtree: true, characterData: true });
      mountVitals();
      mountVitalsFx();
      checkVitals();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
